import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function RealPainSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 md:py-24 bg-brand-white relative border-t border-brand-gold/10" data-id="element-409" data-mp="3btblryour7pk">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-410" data-mp="3gseh2rf15zkc">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6
      }} data-id="element-411" data-mp="3gqv171xadqj3">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-412" data-mp="2x4f5xfgk0qee">
            {t('testimonials.title')}
          </h2>
          <div className="w-16 h-1 bg-brand-gold mb-8" data-id="element-413" data-mp="2j5p980xncsqk"></div>

          <div className="space-y-6 text-lg text-brand-charcoal" data-id="element-414" data-mp="2o3qzp6xejuc2">
            <p className="font-medium" data-id="element-415" data-mp="2o2z4hx7pvymb">{t('testimonials.p1')}</p>
            <p className="text-xl font-serif text-brand-gold-light italic" data-id="element-416" data-mp="1zt6eunikqc4u">
              {t('testimonials.highlight')}
            </p>
            <p data-id="element-417" data-mp="1ux8xqezhl1r0">{t('testimonials.p2')}</p>
            <p data-id="element-418" data-mp="28vfozc9xk3hp">{t('testimonials.p3')}</p>
            <p className="font-medium" data-id="element-419" data-mp="28ue1g8bq9oj3">{t('testimonials.p4')}</p>
            <p data-id="element-420" data-mp="23vkxb6ibz9vl">{t('testimonials.p5')}</p>
          </div>
        </motion.div>
      </div>
    </section>;
}